export default __webpack_public_path__ + "static/media/Slots_Arrow_Right.a22b037d.png";